<template>
  <table>
    <colgroup>
      <col style="background: #f9f9f9" />
      <col />
      <col />
      <col />
      <col style="width: 50px" />
      <col v-if="usePrint && !isPrint" style="width: 50px" />
    </colgroup>
    <thead>
      <tr>
        <th>{{ $t('항목별') }}</th>
        <th>{{ $t('전월누적금액') }}</th>
        <th>{{ $t('당월사용금액') }}</th>
        <th>{{ $t('누계사용금액') }}</th>
        <th>{{ $t('내역') }}</th>
        <th v-if="usePrint && !isPrint">{{ $t('인쇄') }}</th>
      </tr>
    </thead>
    <table-budget-content-body
      v-for="(trData, trData_i) in tableData"
      :key="trData.label"
      :list-number="trData_i + 1"
      :is-print="isPrint"
      :readonly="readonly"
      :usePrint="usePrint"
      :header="header"
      v-model.lazy="tableData[trData_i]"
    />
    <tbody>
      <tr>
        <td>계</td>

        <td>
          <p v-if="isPrint" class="print-input">{{ allPrev | comma }}</p>
          <CommaInput
            v-else
            class="w-full flex-1 p-1"
            placeholder="자동입력(전체 합산)"
            :value="allPrev"
            readonly
          />
        </td>
        <td>
          <p v-if="isPrint" class="print-input">{{ allNow | comma }}</p>
          <CommaInput
            v-else
            class="w-full flex-1 p-1"
            placeholder="자동입력(전체 합산)"
            :value="allNow"
            readonly
          />
        </td>
        <td>
          <p v-if="isPrint" class="print-input">{{ allTotal | comma }}</p>
          <CommaInput
            v-else
            class="w-full flex-1 p-1"
            placeholder="자동입력(전체 합산)"
            readonly
            :value="allTotal"
          />
        </td>
        <td></td>
        <td v-if="usePrint && !isPrint">
          <img
            v-if="false"
            class="mx-auto cursor-pointer"
            src="@/assets/images/icon/icon-printer.svg"
            @click="onClickPrint('total')"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import TableBudgetContentBody from "./TableBudgetContentBody.vue";

export default {
  components: {
    TableBudgetContentBody,
  },
  props: {
    value: Array,
    usePrint: Boolean,
    isPrint: Boolean,
    readonly: Boolean,
    header: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.value && this.value.length > 0) {
          this.tableData = this.value;

          for (const row of this.tableData) {
            if (row.detail.total !== row.detail.prev + row.detail.now) {
              row.detail.total = row.detail.prev + row.detail.now;
            }
          }
        }
      },
    },
    tableData: {
      immediate: true,
      deep: true,
      handler(data) {
        this.$emit("input", data);
        this.$emit("budgetTotal", {
          prev: this.allPrev,
          now: this.allNow,
          total: this.allTotal,
        });
      },
    },
    isPrint(value) {
      if (value) {
        this.tableData = this.tableData.map((data) => {
          return { ...data, arcc: false };
        });
      }
    },
  },
  computed: {
    allPrev() {
      const _prev = this.tableData.reduce((prev, data) => {
        return prev + Number(data.detail.prev || 0);
      }, 0);
      return _prev;
    },
    allNow() {
      const _now = this.tableData.reduce((prev, data) => {
        if (data.detail.now) return prev + Number(data.detail.now);
        else return prev;
      }, 0);
      return _now;
    },
    allTotal() {
      const _prev = this.tableData.reduce((prev, data) => {
        return prev + Number(data.detail.total || 0);
      }, 0);
      return _prev;
    },
  },
  data() {
    return {
      tableData: this.value,
      selected: [],
    };
  },
  filters: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    onClickPrint(type) {},
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;

  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;

  border-collapse: collapse;
  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 16px 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        &:first-child {
          text-align: center;
          padding: 16px 6px;
        }
        border: solid #cdcdcd 1px;
      }
    }
  }
}
</style>
